/**
 * @description
 * - функция принимает массив, разделяет пополам и возвращает объект где,
 * arrayFirstHalf - первая половина и arraySecondHalf - вторая
 * - no mutating
 *
 * @param array T[]
 * @returns {object} { arrayFirstHalf: T[], arraySecondHalf: T[] }
 */
export function splitArrayInHalf<T>(array: T[]): { arrayFirstHalf: T[]; arraySecondHalf: T[] } {
  const halfwayThrough = Math.ceil(array.length / 2);

  const arrayFirstHalf = array.slice(0, halfwayThrough);
  const arraySecondHalf = array.slice(halfwayThrough, array.length);

  return {
    arrayFirstHalf,
    arraySecondHalf,
  };
}
